import { render, staticRenderFns } from "./GpxTracks.vue?vue&type=template&id=bfc1c0da&"
import script from "./GpxTracks.vue?vue&type=script&lang=ts&"
export * from "./GpxTracks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports